// #tag: FIREBASE POPUP AUTHENTICATION ADAPTER
// #purpose: Launches Firebase popup authentication provider and extracts OpenID Connect (OIDC) ID tokens for backend exchange.
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirebaseApp } from './config';

export async function signInWithGoogle(): Promise<string> {
  const app = getFirebaseApp();
  if (!app) throw new Error('Firebase is not configured.');
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result.user.getIdToken();
}
